export default "__VITE_ASSET__03abf328__"